module.exports = __webpack_public_path__ + "img/keyboard_65_less.e93fa821.png";